import { FontAwesome5 } from '@expo/vector-icons';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { useTheme } from 'react-native-paper';

import { flex, width } from '../../style-utils';
import { OETouchableOpacity } from '../oe-touchable-opacity/oe-touchable-opacity';

export interface ArrowButtonProps {
  disabled: boolean;
  direction?: 'up' | 'right' | 'left' | 'down';
  size?: number;
  color?: string;
  disabledColor?: string;
  arrowStyle?: StyleProp<ViewStyle>;
  onPress: () => void;
  testID?: string;
}

export const ArrowButton = ({
  disabled,
  direction = 'left',
  size = 18,
  color,
  disabledColor,
  arrowStyle,
  onPress,
  testID,
}: ArrowButtonProps) => {
  const { colors } = useTheme();

  return (
    <OETouchableOpacity
      testID={testID}
      onPress={onPress}
      disabled={disabled}
      style={[
        width(size),
        flex('align-content-center', 'justify-content-center'),
      ]}
    >
      <FontAwesome5
        size={size}
        style={arrowStyle}
        disabled={disabled}
        name={`chevron-${direction}`}
        color={
          disabled ? disabledColor ?? colors.border : color ?? colors.primary
        }
      />
    </OETouchableOpacity>
  );
};
